import styled from 'styled-components';
import { device } from './responsives';

export const ProgressBarContainer = styled.div`
  padding: 0;
  @media ${device.minlaptop}{
    display: inline-block;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    float: right;
    margin-right: 60px;
  }

  @media ${device.maxlaptop}{
    display: block;
    margin: 12px 60px auto;
    max-width: 670px;
  }

  @media ${device.mobileL}{
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 0px;
  }
`

export const ProgressBarStyle = styled.div`
  display: block;
  box-sizing: border-box;
  width: auto;
  height: auto;
  background-color: #8e8e93;
  padding: 0px 16px;
  border-radius: 4px;
  background-color: #8e8e93;
  margin: 0px;

`

export const JourneySummary = styled.p`
  display: inline-block;
  color: #ffffff;
  font-size: 20px;
  font-family: Avenir;
  font-weight: 500;
  line-height: normal;
  margin: 16px 0px 16px 0px;
`
